import { useMemo } from 'react'
import { useThemeVariable } from '@ublique/components/Theme'

const useColorTheme = () => {
  const defaultColor = useThemeVariable('interactive04')
  const labelColor = useThemeVariable('text01')
  const green = useThemeVariable('support02')
  const yellow = useThemeVariable('support03')

  const colorTheme = useMemo(
    () => ({
      defaultColor,
      labelColor,
      needs: green,
      notCovered: yellow
    }),
    [defaultColor, green, labelColor, yellow]
  )

  return colorTheme
}

export default useColorTheme
